export default [
	//入库单[列表]
	{
		path: 'stockin',
		name: 'm_stockin',
		meta: {
			templateManage: {
				workType: 4,
				print: 'b_stockin_printtemplate',
				export: 'b_stockin_exporttemplate'
			},
			appView: {
				viewId: '90005',
				detailView: [{
					name: '详情-入库商品',
					viewId: '90016'
				}],
				auth: 'b_stockin_viewmanage'
			}
		},
		component: () => import('@/pages/storage/stockin_list')
	},
	//出库单[列表]
	{
		path: 'stockout',
		name: 'm_stockout',
		meta: {
			templateManage: {
				workType: 5,
				print: 'b_stockout_printtemplate',
				export: 'b_stockout_exporttemplate'
			},
			appView: {
				viewId: '90006',
				detailView: [{
					name: '详情-出库商品',
					viewId: '90017'
				}],
				auth: 'b_stockout_viewmanage'
			}
		},
		component: () => import('@/pages/storage/stockout_list')
	},
	//盘点单[列表]
	{
		path: 'inventory',
		name: 'm_inventory',
		meta: {
			templateManage: {
				workType: 6,
				print: 'b_inventory_printtemplate',
				export: 'b_inventory_exporttemplate'
			},
			appView: {
				viewId: '90033',
				detailView: [{
					name: '详情-盘点商品',
					viewId: '90019'
				}],
				auth: 'b_inventory_viewmanage'
			}
		},
		component: () => import('@/pages/storage/inventory_list')
	},
	//库存收发明细[列表]
	{
		path: 'stock/record',
		name: 'm_stock_record',
		meta: {
			templateManage: {
				workType: 16,
				export: 'b_stock_record_exporttemplate'
			},
			appView: {
				viewId: '90008',
				auth: 'b_stock_record_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/storage/stock_record_list')
	},
	//库存余额[列表]
	{
		path: 'stock',
		name: 'm_stock',
		meta: {
			templateManage: {
				workType: 17,
				export: 'b_stock_exporttemplate'
			},
			appView: {
				viewId: '90007',
				detailView: [{
					name: '详情-出入库单',
					viewId: '90018'
				}, {
					name: '详情-库存余额明细',
					viewId: '90031',
					disabled() {
						return this.systemConfig.batch_stock != 1;
					}
				}],
				auth: 'b_stock_viewmanage'
			}
		},
		component: () => import('@/pages/storage/stock_list')
	},
	//库存余额明细[列表]
	{
		path: 'stock/detail',
		name: 'm_stock_detail',
		meta: {
			templateManage: {
				workType: 18,
				export: 'b_stock_detail_exporttemplate'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/storage/stock_detail_list')
	},
	//进销存汇总[列表]
	{
		path: 'stock/summary',
		name: 'm_stock_summary',
		meta: {
			templateManage: {
				workType: 19,
				export: 'b_stock_summary_exporttemplate'
			}
		},
		component: () => import('@/pages/storage/stock_summary_list')
	},
	//库存变更记录[列表]
	{
		path: 'stock/change/record',
		name: 'm_stock_change_record',
		meta: {
			templateManage: {
				workType: 25,
				export: 'b_stock_change_record_exporttemplate'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/storage/stock_change_record_list')
	},
	//库存批次[列表]
	{
		path: 'stock/batch',
		name: 'm_stock_batch',
		meta: {
			templateManage: {
				workType: 49,
				export: 'b_stockbatch_exporttemplate'
			}
		},
		component: () => import('@/pages/storage/stockbatch_list')
	},
];